export default "__VITE_ASSET__b44f2bf7__$_?nuxt_component=async&nuxt_component_name=SvgoNuxt__"